var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"part-list-footer"},[_c('button',{staticClass:"part-list-print v-button-filled",on:{"click":_vm.printModal}},[_c('span',[_vm._v(_vm._s(_vm.t.t('print.button')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }